<template>
  <div class="gps-surveillance slide">
    <HorizontalAnimation :animation="animation" :loop="true" />
    <div class="horizontal-layout animated fadeIn delay-1s">
      <p class="store">STORE 0111</p>
      <h1>GPS Surveillance</h1>
      <p>Due to the volume of incidents and the evidence gathered so far, approvals are made for law enforcement (LE) to apply a GPS to the cargo van for further intelligence gathering.</p>
    </div>
    <router-link to="/pawn-shop">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import GPsSurveillance from '@/assets/gps-surveillance.js'

export default {
  name: 'gps-surveillance',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: GPsSurveillance,
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
  .horizontal-layout {
    margin-top: 20px;
  }
</style>
